import React, { useEffect, useState, useContext } from "react";
import { FaPlus, FaUniversity } from "react-icons/fa";
import "../styles/account.css";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const BankAccount = () => {
  const navigate = useNavigate();
  const { fetchBankAccounts } = useContext(AuthContext);
  const [bankAccounts, setBankAccounts] = useState([]);

  useEffect(() => {
    const loadAccounts = async () => {
      const result = await fetchBankAccounts();
      if (!result.error) {
        setBankAccounts(result.bankAccounts);
      } else {
        console.error(result.error);
      }
    };

    loadAccounts();
  }, [fetchBankAccounts]);

  const addBankAccount = () => {
    navigate("/add-bank-account");
  };

  return (
    <div className="bank-account-container">
      <button className="add-account-btn" onClick={addBankAccount}>
        <FaPlus className="plus-icon" /> Add Bank Account
      </button>

      <div className="account-list">
        {bankAccounts.map((account, index) => (
          <div className="account-card" key={index}>
            <div className="card-header">
              <FaUniversity className="wallet-icon" />
            </div>
            <div className="card-body">
              <div className="row-top">
                <div className="account-number">{account.accountNumber}</div>
                <div className="right-label">Account Number</div>
              </div>
              <div className="row-bottom">
                <div className="account-name">{account.accountName.toUpperCase()}</div>
                <div className="bank-name">{account.bankName.toUpperCase()}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BankAccount;
